const r="Error, our specialists already know about it and take measures",e="A network error has occurred. Try reloading the page";export{r as ERROR_MESSAGE_DEFAULT,e as ERROR_NETWORK_MESSAGE_DEFAULT};
